/* Shoppable Video - lazy reel + slider arrows + draggable bubble + swipe-reel modal.
   VIDEO MODEL: MAX_PLAY reel videos play at once (nearest centre); to720() forces 720p;
   tiles loop first PREVIEW_SECS seconds; native MP4 (HLS only on Safari).
   ANALYTICS: fires GA4 events to property GA4_ID (G-S6CPSEMQRW): shoppable_reel_view (reach),
   shoppable_video_open (views), shoppable_product_click (clicks). On product click it also sets a
   hidden cart attribute _reel_source so reel-driven add-to-carts/orders can be tagged in Shopify. */
(function(){
  var PREVIEW_SECS = 5;
  var MAX_PLAY = 999;
  var GA4_ID = 'G-S6CPSEMQRW';
  var reelVisible = [];
  var manageRAF = null;
  function nativeHls(v){ return !!(v.canPlayType && v.canPlayType('application/vnd.apple.mpegurl')); }
  function to720(u){ if(!u) return u; return u.replace('HD-1080p-7.2Mbps','HD-720p-4.5Mbps').replace('HD-1080p-3.3Mbps','HD-720p-2.1Mbps'); }
  function playVid(v){ if(!v) return; var p=v.play(); if(p&&p.catch) p.catch(function(){}); }
  function pauseVid(v){ if(!v) return; try{v.pause();}catch(_){} }
  function reveal(v){ if(v) v.style.opacity='1'; }
  function track(name,params){
    params=params||{};
    try{ if(typeof window.gtag==='function'){ if(!window.__pmGa4){ try{ window.gtag('config',GA4_ID,{send_page_view:false}); }catch(_){} window.__pmGa4=1; } params.send_to=GA4_ID; window.gtag('event',name,params); } }catch(_){}
    try{ if(window.dataLayer && window.dataLayer.push){ var o={event:name}; for(var k in params){ o[k]=params[k]; } window.dataLayer.push(o); } }catch(_){}
  }
  function trackProductClick(a,h){
    var name=''; try{ name=(a.querySelector('.shopvid-modal__ptitle')||{}).textContent||''; }catch(_){}
    track('shoppable_product_click',{item_name:name, link_url:h});
    try{ fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{_reel_source:(name||h)}}),keepalive:true}); }catch(_){}
  }
  function capPreview(v){
    if(v.dataset.capped==='1') return; v.dataset.capped='1';
    v.addEventListener('timeupdate',function(){ if(PREVIEW_SECS>0 && v.currentTime>=PREVIEW_SECS){ try{ v.currentTime=0; }catch(_){} } });
  }
  function setSource(v){
    if(!v || v.dataset.ready==='1') return;
    var hls=v.dataset.hls||'', mp4=to720(v.dataset.mp4||'');
    if(mp4){ v.src=mp4; }
    else if(hls && nativeHls(v)){ v.src=hls; }
    else if(hls){ v.src=hls; }
    v.dataset.ready='1';
  }
  function teardown(v){ v.removeAttribute('src'); v.dataset.ready=''; try{v.load();}catch(e){} }
  function manageReel(){
    manageRAF=null;
    if(!reelVisible.length) return;
    var vpc = window.innerWidth/2;
    var arr = reelVisible.slice().sort(function(a,b){
      var ra=a.getBoundingClientRect(), rb=b.getBoundingClientRect();
      return Math.abs((ra.left+ra.width/2)-vpc) - Math.abs((rb.left+rb.width/2)-vpc);
    });
    arr.forEach(function(v,i){ if(i<MAX_PLAY){ setSource(v); playVid(v); } else { pauseVid(v); } });
  }
  function scheduleManage(){ if(manageRAF) return; manageRAF=requestAnimationFrame(manageReel); }
  var io=('IntersectionObserver' in window)?new IntersectionObserver(function(entries){
    entries.forEach(function(e){ var v=e.target; var isFloat=v.closest&&v.closest('.shopvid-float');
      if(e.isIntersecting){
        if(isFloat){ setSource(v); playVid(v); }
        else if(reelVisible.indexOf(v)<0){ reelVisible.push(v); }
      } else {
        var i=reelVisible.indexOf(v); if(i>=0) reelVisible.splice(i,1);
        pauseVid(v);
      }
    });
    scheduleManage();
  },{threshold:0.5}):null;

  var modal,track2,soundBtn,dotsEl,hintEl,slides=[],activeIdx=0,muted=true,scrollT=null,pausedReels=[];
  function cardHTML(pr){
    var price='<span class="shopvid-modal__pprice"><b>'+(pr.price||'')+'</b>'+(pr.compareAt?'<s>'+pr.compareAt+'</s>':'')+'</span>';
    var img=pr.image?'<img class="shopvid-modal__pimg" src="'+pr.image+'" alt="" loading="lazy">':'';
    return '<a class="shopvid-modal__product" href="'+pr.url+'">'+img
      +'<div class="shopvid-modal__pinfo"><div class="shopvid-modal__ptitle">'+pr.title+'</div>'+price+'</div>'
      +'<span class="shopvid-modal__popen" aria-hidden="true">&#8599;</span></a>';
  }
  function hintHTML(){
    return '<div class="shopvid-modal__hintsweep"><svg viewBox="0 0 250 46" focusable="false" aria-hidden="true">'
      +'<path class="h1" d="M69,11 L59,23 L69,35" stroke-width="3.4"></path>'
      +'<path class="h2" d="M87,12 L78,23 L87,34" stroke-width="3.2"></path>'
      +'<path class="h3" d="M105,13 L97,23 L105,33" stroke-width="3"></path>'
      +'<path class="h4" d="M123,14 L116,23 L123,32" stroke-width="2.8"></path>'
      +'<path class="h5" d="M141,15 L135,23 L141,31" stroke-width="2.6"></path>'
      +'<path class="h6" d="M159,16 L154,23 L159,30" stroke-width="2.4"></path>'
      +'<path class="h7" d="M177,17 L173,23 L177,29" stroke-width="2.2"></path>'
      +'</svg></div>';
  }
  function hideHint(){ if(modal) modal.classList.remove('has-hint'); }
  function pauseReels(){ reelVisible.forEach(function(vv){ if(vv && !vv.paused){ pauseVid(vv); pausedReels.push(vv); } }); }
  function resumeReels(){ pausedReels=[]; scheduleManage(); }
  function buildModal(){
    modal=document.createElement('dialog'); modal.className='shopvid-modal'; modal.setAttribute('role','dialog'); modal.setAttribute('aria-modal','true');
    modal.innerHTML='<div class="shopvid-modal__backdrop" data-close></div>'
      +'<button class="shopvid-modal__close" data-close aria-label="Close">&times;</button>'
      +'<button class="shopvid-modal__sound" data-sound aria-label="Sound">&#128263;</button>'
      +'<button class="shopvid-modal__nav shopvid-modal__nav--prev" data-prev aria-label="Previous">&#8249;</button>'
      +'<button class="shopvid-modal__nav shopvid-modal__nav--next" data-next aria-label="Next">&#8250;</button>'
      +'<div class="shopvid-modal__viewport"><div class="shopvid-modal__track"></div></div>';
    document.body.appendChild(modal);
    track2=modal.querySelector('.shopvid-modal__track');
    soundBtn=modal.querySelector('[data-sound]');
    hintEl=document.createElement('div'); hintEl.className='shopvid-modal__hint'; hintEl.setAttribute('aria-hidden','true');
    hintEl.innerHTML=hintHTML();
    modal.querySelector('.shopvid-modal__viewport').appendChild(hintEl);
    dotsEl=document.createElement('div'); dotsEl.className='shopvid-modal__dots';
    modal.querySelector('.shopvid-modal__viewport').appendChild(dotsEl);
    dotsEl.addEventListener('click',function(e){ var b=e.target.closest?e.target.closest('[data-dot]'):null; if(!b)return; var i=parseInt(b.getAttribute('data-dot'),10);
      if(i!==activeIdx && slides[i]){ hideHint(); if('scrollTo' in track2){ track2.scrollTo({left:centerOf(slides[i]),behavior:'smooth'}); } else { track2.scrollLeft=centerOf(slides[i]); } setTimeout(updateActive,120); setTimeout(updateActive,450); } });
    track2.addEventListener('pointerdown',hideHint,{passive:true});
    modal.addEventListener('click',function(e){
      if(e.target.closest('.shopvid-modal__product')) return;
      if(e.target.closest('[data-close]')) closeModal();
      else if(e.target.closest('[data-prev]')) nav(-1);
      else if(e.target.closest('[data-next]')) nav(1);
      else if(e.target.closest('[data-sound]')) toggleSound();
    });
    document.addEventListener('keydown',function(e){ if(!modal.classList.contains('is-open'))return; if(e.key==='ArrowRight')nav(1); else if(e.key==='ArrowLeft')nav(-1); });
    modal.addEventListener('cancel',function(e){ e.preventDefault(); closeModal(); });
    track2.addEventListener('scroll',onScroll,{passive:true});
  }
  function centerOf(s){ return s.offsetLeft + s.offsetWidth/2 - track2.clientWidth/2; }
  function nearestIdx(){ if(!slides.length) return 0; var c=track2.scrollLeft+track2.clientWidth/2,best=0,bd=1e9;
    slides.forEach(function(s,i){ var sc=s.offsetLeft+s.offsetWidth/2, d=Math.abs(sc-c); if(d<bd){bd=d;best=i;} }); return best; }
  function updateActive(){ var idx=nearestIdx(); activeIdx=idx;
    slides.forEach(function(s,i){ var v=s.querySelector('.shopvid-modal__svideo');
      if(Math.abs(i-idx)<=1){ setSource(v); }
      if(i===idx){ s.classList.add('is-active'); v.muted=muted; playVid(v); }
      else { s.classList.remove('is-active'); pauseVid(v); } });
    if(dotsEl){ var strip=dotsEl.firstChild; if(strip){ var dd=strip.children; for(var k=0;k<dd.length;k++){ var dist=Math.abs(k-idx); var sc=dist===0?1.25:dist===1?1:dist===2?0.66:dist===3?0.45:0; dd[k].style.transform='scale('+sc+')'; dd[k].style.opacity=dist>3?'0':'1'; dd[k].classList.toggle('is-active', k===idx); } strip.style.transform='translateY(-50%) translateX('+(42-idx*14)+'px)'; } } }
  function onScroll(){ clearTimeout(scrollT); scrollT=setTimeout(updateActive,80); }
  function openModal(tiles,i){
    if(!modal) buildModal();
    pauseReels();
    track2.innerHTML=''; slides=[];
    tiles.forEach(function(tile){
      var sv=tile.querySelector('.shopvid__video');
      var slide=document.createElement('div'); slide.className='shopvid-modal__slide';
      var vid=document.createElement('video'); vid.className='shopvid-modal__svideo'; vid.setAttribute('playsinline',''); vid.loop=true; vid.muted=true;
      vid.dataset.hls=sv.dataset.hls||''; vid.dataset.mp4=sv.dataset.mp4hd||sv.dataset.mp4||'';
      var poster=sv.getAttribute('poster'); if(poster) vid.poster=poster;
      slide.appendChild(vid);
      var prods=[]; try{ prods=JSON.parse(tile.dataset.products||'[]'); }catch(_){}
      if(prods.length){ var pc=document.createElement('div'); pc.className='shopvid-modal__products'; pc.innerHTML=prods.map(cardHTML).join(''); slide.appendChild(pc); dragScroll(pc); }
      var rail=document.createElement('div'); rail.className='shopvid-modal__rail';
      rail.innerHTML='<button class="shopvid-modal__railbtn" data-like aria-label="Like"><span class="ic">&#9825;</span><span class="ct">0</span></button>'
        +'<button class="shopvid-modal__railbtn" data-share aria-label="Share"><span class="ic">&#8599;</span><span class="ct">Share</span></button>';
      slide.appendChild(rail);
      (function(sl){
        var lb=sl.querySelector('[data-like]'), sh=sl.querySelector('[data-share]');
        lb.addEventListener('click',function(e){ e.stopPropagation(); var ic=lb.querySelector('.ic'),ct=lb.querySelector('.ct'),n=parseInt(ct.textContent,10)||0;
          if(lb.classList.toggle('is-liked')){ ic.innerHTML='&#9829;'; ct.textContent=n+1; } else { ic.innerHTML='&#9825;'; ct.textContent=Math.max(0,n-1); } });
        sh.addEventListener('click',function(e){ e.stopPropagation(); var a=sl.querySelector('.shopvid-modal__product'); var url=a?a.href:location.href;
          if(navigator.share){ navigator.share({url:url}).catch(function(){}); }
          else if(navigator.clipboard){ navigator.clipboard.writeText(url); var ct=sh.querySelector('.ct'); ct.textContent='Copied'; setTimeout(function(){ ct.textContent='Share'; },1500); } });
        sl.addEventListener('click',function(e){ if(e.target.closest('.shopvid-modal__rail')||e.target.closest('.shopvid-modal__products')) return;
          if(slides.length<2) return; var r=sl.getBoundingClientRect(); nav((e.clientX-r.left) < r.width*0.35 ? -1 : 1); });
      })(slide);
      track2.appendChild(slide); slides.push(slide);
    });
    dotsEl.innerHTML='<div class="shopvid-modal__dotstrip">'+slides.map(function(_,i){ return '<button class="shopvid-modal__dot" data-dot="'+i+'" aria-label="Go to video '+(i+1)+'"></button>'; }).join('')+'</div>';
    dotsEl.style.display = slides.length>1 ? 'block' : 'none';
    var hintOn = slides.length>1;
    if(hintOn && tiles.length){ var rootEl = tiles[0].closest ? tiles[0].closest('[data-shopvid]') : null; if(rootEl && rootEl.getAttribute('data-hint')==='0') hintOn=false; }
    modal.classList.toggle('has-hint', hintOn);
    muted=true; soundBtn.innerHTML='&#128263;';
    modal.classList.add('is-open'); document.documentElement.style.overflow='hidden';
    if(!modal.open){ try{ modal.showModal(); }catch(_){} }
    activeIdx=i||0;
    try{ var ot=tiles[activeIdx]; var op=[]; try{op=JSON.parse(ot.dataset.products||'[]');}catch(_){} track('shoppable_video_open',{video_index:activeIdx, item_name:(op[0]?op[0].title:'')}); }catch(_){}
    var target=slides[activeIdx];
    slides.forEach(function(o){ o.classList.toggle('is-active', o===target); });
    if(target){ var av=target.querySelector('.shopvid-modal__svideo'); setSource(av); if(av){ av.muted=muted; av.preload='auto'; playVid(av); } }
    requestAnimationFrame(function(){
      var prev=track2.style.scrollBehavior; track2.style.scrollBehavior='auto';
      track2.scrollLeft=centerOf(target);
      track2.style.scrollBehavior=prev||'';
      updateActive();
    });
  }
  function closeModal(){ modal.classList.remove('is-open'); modal.classList.remove('has-hint'); document.documentElement.style.overflow='';
    slides.forEach(function(s){ var v=s.querySelector('.shopvid-modal__svideo'); teardown(v); });
    if(modal.open){ try{ modal.close(); }catch(_){} }
    resumeReels(); }
  function nav(d){
    if(!slides.length) return;
    hideHint();
    var raw=activeIdx+d, wrapped=false, t;
    if(raw<0){ t=slides.length-1; wrapped=true; }
    else if(raw>slides.length-1){ t=0; wrapped=true; }
    else { t=raw; }
    if(t===activeIdx) return;
    var s=slides[t];
    if('scrollTo' in track2){ track2.scrollTo({left:centerOf(s),behavior:wrapped?'auto':'smooth'}); } else { track2.scrollLeft=centerOf(s); }
    activeIdx=t;
    setTimeout(updateActive,120); setTimeout(updateActive,450); }
  function toggleSound(){ muted=!muted; soundBtn.innerHTML=muted?'&#128263;':'&#128266;'; var s=slides[activeIdx]; if(s){ var v=s.querySelector('.shopvid-modal__svideo'); if(v) v.muted=muted; } }

  function goToProduct(el){ var a=(el&&el.closest)?el.closest('a.shopvid-modal__product'):null; if(a){ var h=a.getAttribute('href'); if(h){ trackProductClick(a,h); window.location.href=h; return true; } } return false; }

  function dragScroll(el){
    var down=false,sx=0,sl=0,moved=false,lastX=0,vx=0,lastT=0,raf=null,captured=false,pid=null;
    function nowT(){ return (window.performance&&performance.now)?performance.now():Date.now(); }
    el.style.cursor='grab'; el.style.userSelect='none'; el.style.webkitUserSelect='none';
    function stopM(){ if(raf){ cancelAnimationFrame(raf); raf=null; } }
    el.addEventListener('dragstart',function(e){ e.preventDefault(); });
    el.addEventListener('pointerdown',function(e){ stopM(); down=true; moved=false; captured=false; pid=e.pointerId; sx=e.clientX; sl=el.scrollLeft; lastX=e.clientX; vx=0; lastT=nowT(); el.style.cursor='grabbing'; });
    el.addEventListener('pointermove',function(e){ if(!down) return; var dx=e.clientX-sx;
      if(!moved){ if(Math.abs(dx)<=4) return; moved=true; try{ el.setPointerCapture(pid); captured=true; }catch(_){} }
      el.scrollLeft=sl-dx; var t=nowT(),dt=t-lastT; if(dt>0){ vx=0.8*vx+0.2*((e.clientX-lastX)/dt); } lastX=e.clientX; lastT=t; if(e.cancelable) e.preventDefault(); });
    function end(e){ if(!down) return; down=false; el.style.cursor='grab';
      if(captured){ try{ el.releasePointerCapture(pid); }catch(_){} captured=false; }
      if(!moved){ goToProduct(e&&e.target); return; }
      var v=vx*16; function step(){ if(Math.abs(v)<0.4){ raf=null; return; } el.scrollLeft-=v; v*=0.93; raf=requestAnimationFrame(step); } if(Math.abs(v)>1.2){ raf=requestAnimationFrame(step); } }
    el.addEventListener('pointerup',end); el.addEventListener('pointercancel',function(){ down=false; el.style.cursor='grab'; });
    el.addEventListener('click',function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); moved=false; } },true);
  }

  function pageScroll(reel,dir){
    var max=reel.scrollWidth-reel.clientWidth;
    var step=Math.round(reel.clientWidth*0.85)*dir;
    var target=reel.scrollLeft+step;
    if(target>max-4){ target=(reel.scrollLeft>=max-4)?0:max; }
    else if(target<0){ target=(reel.scrollLeft<=4)?max:0; }
    if('scrollTo' in reel){ reel.scrollTo({left:target,behavior:'smooth'}); } else { reel.scrollLeft=target; }
  }
  function setupArrows(wrap){
    if(wrap.dataset.arr==='1') return; wrap.dataset.arr='1';
    var reel=wrap.querySelector('.shopvid__reel'); if(!reel) return;
    var prev=wrap.querySelector('.shopvid__nav--prev'), next=wrap.querySelector('.shopvid__nav--next');
    function upd(){ wrap.classList.toggle('is-scrollable', reel.scrollWidth > reel.clientWidth + 8); }
    if(prev) prev.addEventListener('click',function(){ pageScroll(reel,-1); });
    if(next) next.addEventListener('click',function(){ pageScroll(reel, 1); });
    reel.addEventListener('scroll',upd,{passive:true});
    var endT=null;
    function atEnd(){ var m=reel.scrollWidth-reel.clientWidth; return m>8 && reel.scrollLeft>=m-4; }
    reel.addEventListener('scroll',function(){ clearTimeout(endT); if(!atEnd()) return; endT=setTimeout(function(){ if(!atEnd()) return; if('scrollTo' in reel){ reel.scrollTo({left:0,behavior:'smooth'}); } else { reel.scrollLeft=0; } },900); },{passive:true});
    upd(); window.addEventListener('resize',upd); setTimeout(upd,600); setTimeout(upd,1500);
  }

  function initReel(root){
    if(root.dataset.init==='1') return; root.dataset.init='1';
    var tiles=[].slice.call(root.querySelectorAll('.shopvid__tile'));
    tiles.forEach(function(tile){
      var v=tile.querySelector('.shopvid__video');
      if(v){ v.style.opacity='0'; v.style.transition='opacity .35s ease'; v.addEventListener('playing',function(){ reveal(v); }); capPreview(v); if(io) io.observe(v); else { setSource(v); playVid(v); } }
      tile.addEventListener('click',function(){ var fl=tile.closest('.shopvid-float'); if(fl && fl._sc){ fl._sc=false; return; } openModal(tiles, tiles.indexOf(tile)); });
    });
    if(!(root.classList && root.classList.contains('shopvid-float')) && ('IntersectionObserver' in window)){
      var seen=false;
      var rio=new IntersectionObserver(function(ents){ ents.forEach(function(en){ if(en.isIntersecting && !seen){ seen=true; track('shoppable_reel_view',{tiles:tiles.length}); rio.disconnect(); } }); },{threshold:0.3});
      rio.observe(root);
    }
    var reel=root.querySelector('.shopvid__reel'); if(reel){ reel.addEventListener('scroll',scheduleManage,{passive:true}); }
    var wrap=root.querySelector('.shopvid__wrap'); if(wrap) setupArrows(wrap);
  }
  window.addEventListener('scroll',scheduleManage,{passive:true});
  document.addEventListener('click',function(e){
    var c=e.target.closest?e.target.closest('.shopvid-float__close'):null; if(!c) return;
    var f=c.closest('.shopvid-float'); if(f){ f.querySelectorAll('video').forEach(function(v){ pauseVid(v); }); f.remove(); }
  });
  function setupDrag(f){
    if(f.dataset.drag==='1') return; f.dataset.drag='1';
    var startX,startY,ox,oy,dragging=false,moved=false;
    function down(e){
      if(e.target.closest && e.target.closest('.shopvid-float__close')) return;
      dragging=true; moved=false;
      var r=f.getBoundingClientRect();
      f.style.left=r.left+'px'; f.style.top=r.top+'px'; f.style.right='auto'; f.style.bottom='auto'; f.style.transform='none';
      startX=e.clientX; startY=e.clientY; ox=r.left; oy=r.top;
      try{ f.setPointerCapture(e.pointerId); }catch(_){}
    }
    function move(e){
      if(!dragging) return;
      var dx=e.clientX-startX, dy=e.clientY-startY;
      if(Math.abs(dx)>4||Math.abs(dy)>4) moved=true;
      var nx=Math.min(window.innerWidth-f.offsetWidth, Math.max(0, ox+dx));
      var ny=Math.min(window.innerHeight-f.offsetHeight, Math.max(0, oy+dy));
      f.style.left=nx+'px'; f.style.top=ny+'px';
    }
    function up(){ if(!dragging) return; dragging=false; f._sc=true;
      if(!moved){ var t=[].slice.call(f.querySelectorAll('.shopvid__tile')); if(t.length) openModal(t,0); } }
    f.addEventListener('pointerdown',down);
    f.addEventListener('pointermove',move);
    f.addEventListener('pointerup',up);
    f.addEventListener('pointercancel',up);
  }
  function initAll(){ document.querySelectorAll('[data-shopvid]').forEach(initReel); document.querySelectorAll('.shopvid-float').forEach(setupDrag); }
  if(document.readyState!=='loading') initAll(); else document.addEventListener('DOMContentLoaded',initAll);
  document.addEventListener('shopify:section:load',function(e){ var r=e.target.querySelector&&e.target.querySelector('[data-shopvid]'); if(r){ r.dataset.init=''; initReel(r); } });
})();
